// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + {"444":"modal/modal","728":"testimonial/testimonial"}[chunkId] + "." + {"444":"5ca41dd26c7573f54bac","728":"eb8b031edb941d005bc2"}[chunkId] + ".css";
};